import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useUiStore } from '../../store/uiStore';
import { ApiError } from '../../api/functionsClient';
import { Spinner } from '../../components/Spinner';

export function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const pushToast = useUiStore((s) => s.pushToast);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      pushToast('success', 'Welcome back!');
      navigate('/');
    } catch (err) {
      const message =
        err instanceof ApiError || err instanceof Error
          ? err.message
          : 'Login failed';
      pushToast('error', message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <h2 className="text-xl font-semibold text-slate-100">Sign in</h2>

      <div>
        <label className="label" htmlFor="login-email">
          Email
        </label>
        <input
          id="login-email"
          type="email"
          autoComplete="email"
          className="input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>

      <div>
        <label className="label" htmlFor="login-password">
          Password
        </label>
        <input
          id="login-password"
          type="password"
          autoComplete="current-password"
          className="input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>

      <button type="submit" className="btn-gold w-full" disabled={submitting}>
        {submitting ? <Spinner /> : 'Sign in'}
      </button>

      <div className="flex items-center justify-between text-sm text-slate-400">
        <Link to="/register" className="hover:text-gold">
          Create account
        </Link>
        <Link to="/forgot-password" className="hover:text-gold">
          Forgot password?
        </Link>
      </div>
    </form>
  );
}
